import Logger from '../helpers/Logger'

export async function polyfill(): Promise<void> {
  const imports: Array<Promise<any>> = []

  if (!Array.prototype.find) {
    imports.push(import(/* webpackChunkName: "arrayFind" */ './arrayFind'))
  }

  if (!Array.from) {
    imports.push(import(/* webpackChunkName: "arrayFrom" */ './arrayFrom'))
  }

  if (!HTMLElement.prototype.matches) {
    imports.push(
      import(/* webpackChunkName: "elementMatches" */ './elementMatches')
    )
  }

  if (typeof Object.assign !== 'function') {
    imports.push(
      import(/* webpackChunkName: "objectAssign" */ './objectAssign')
    )
  }

  if (typeof window.CustomEvent !== 'function') {
    imports.push(import(/* webpackChunkName: "customEvent" */ './customEvent'))
  }

  if (typeof window.Promise !== 'function') {
    imports.push(
      import(
        /* webpackChunkName: "es6Promise" */ 'es6-promise'
      ).then(({ polyfill }) => polyfill())
    )
  }

  if (!isIntersectionObserverDefined()) {
    imports.push(
      import(
        /* webpackChunkName: "intersectionObserver" */ 'intersection-observer/intersection-observer'
      )
    )
  }

  await Promise.all(imports).then(() => {
    Logger.debug(`Polyfills complete v2`)
  })
}

function isIntersectionObserverDefined(): boolean {
  // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  ) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(
        window.IntersectionObserverEntry.prototype,
        'isIntersecting',
        {
          get: function() {
            return this.intersectionRatio > 0
          }
        }
      )
    }
    return true
  }

  return false
}
